module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik01LjY4MjA1IDUuMDQ2NjNDNS4yOTc5MiA1LjQwNDg5IDQuNzAyMDggNS40MDQ4OSA0LjMxNzk1IDUuMDQ2NjNMMS4yMjcxOCAyLjE2NDA1QzAuNTYzMjk4IDEuNTQ0ODggMS4wMDE0MyAwLjQzMjczOSAxLjkwOTIzIDAuNDMyNzM5SDguMDkwNzdDOC45OTg1NyAwLjQzMjczOSA5LjQzNjcgMS41NDQ4OCA4Ljc3MjgyIDIuMTY0MDVMNS42ODIwNSA1LjA0NjYzWiIgZmlsbD0iI0RERERERCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history/showMore.svg
// module id = m0fK
// module chunks = 0